<template>
    <div>
        <v-card>
            <v-card-title class="headline">Please Pick User</v-card-title>
            <v-card-text>
                <v-layout row wrap >
                    <v-flex xs12 sm6 pl-1 v-for="user in usersToPick" :key="user.id">
                        <v-btn block color="primary" @click.prevent="onUserPicked(user)" >{{ user.name }}</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="green darken-1" flat="flat" @click.native="resetUser">Reset</v-btn> -->
                <v-btn color="green darken-1" flat="flat" @click.native="onCloseUserPicker">Close</v-btn>
            </v-card-actions>
        </v-card>
        <!-- {{usersToPick}} -->
                <!-- {{roles}} -->
    </div>

</template>
<<script>
import { mapActions } from 'vuex'

export default {
  props: ['roles'],
  data: () => ({
    //   ifShowPicker: false,
      usersToPick: [],
      // techs: [{id: 12, name: 'Jeff Shi'}, {id: 11, name: 'MK'}]
  }),
  methods: {
      ...mapActions('adminUser', [
          'searchUsers'
      ]),
      onUserPicked (user) {
          console.log('picked')
          this.$emit('onUserPicked', user)
      },
      onCloseUserPicker () {
          this.$emit('onCloseUserPicker')
      },
    //   resetUser () {
    //       let auditLog = Object.assign({})
    //       this.ifShowPicker = false
    //       this.$emit('input', auditLog)
    //   },
    //   showPicker () {
    //       this.ifShowPicker = true
    //   },
      async retrieveUsersForPick() {
          const payload = {
              roles: this.roles,
              isActive: true,
          }
          this.usersToPick = await this.searchUsers(payload)
      }
  },
  watch: {
      'roles' : async function() {
          if (this.roles == null || this.roles.length == 0) {
              console.log('not need load user in user picker')
          } else {
              console.log('will load user for user picker')
              await this.retrieveUsersForPick()
          }
      }
  },
  async mounted () {
          if (this.roles == null || this.roles.length == 0) {
              console.log('not need load user in user picker')
          } else {
              console.log('will load user for user picker')
              this.retrieveUsersForPick()
          }
  }

}
</script>
